import { useState } from "react";
import BuildIcon from "@mui/icons-material/Build";
import SearchIcon from "@mui/icons-material/Search";
import { 
  TextField, 
  InputAdornment, 
  Box, 
  Typography, 
  Chip,
  Tabs,
  Tab,
  Badge
} from "@mui/material";
import PeopleIcon from "@mui/icons-material/People";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import FolderIcon from "@mui/icons-material/Folder";
import SettingsIcon from "@mui/icons-material/Settings";
import MaintenanceGrid from "../../components/module/maintenance/maintenanceGrid/MaintenanceGrid";
import { MODULE_CONFIGS, CATEGORY_LABELS } from './config/maintenanceConfig';
import PageLayout from "../../components/layout/PageLayout";
import "./mantenimiento.scss";

const Mantenimiento = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState<string>("all");

  const maintenanceOptions = Object.entries(MODULE_CONFIGS).map(([key, config]) => ({
    id: key,
    ...config,
  }));

  const filteredOptions = maintenanceOptions.filter(option => {
    const matchesCategory = selectedCategory === "all" || option.category === selectedCategory;
    const matchesSearch = 
      option.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      option.description.toLowerCase().includes(searchTerm.toLowerCase());
    
    return matchesCategory && matchesSearch;
  });

  const getCategoryCount = (category: string) => {
    if (category === "all") return maintenanceOptions.length;
    return maintenanceOptions.filter(opt => opt.category === category).length;
  };

  const categoryIcons: Record<string, JSX.Element> = {
    all: <FolderIcon />,
    recursos_humanos: <PeopleIcon />,
    ventas_compras: <ShoppingCartIcon />,
    catalogos: <FolderIcon />,
    sistema: <SettingsIcon />
  };

  return (
    <PageLayout icon={BuildIcon} title="Mantenimiento de Maestros">
      <div className="maintenance-content">
        <div className="maintenance-header">
          <Box className="header-content">
            <div className="header-info">
              <Typography variant="body2" color="textSecondary" className="header-description">
                Administra los catálogos y configuraciones maestras del sistema
              </Typography>
              <Chip 
                label={`${filteredOptions.length} módulos`}
                size="small"
                color="primary"
                className="modules-count"
              />
            </div>
            <TextField
              placeholder="Buscar módulo..."
              variant="outlined"
              size="small"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="search-field"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Box>
        </div>

        <Box className="category-tabs">
          <Tabs
            value={selectedCategory}
            onChange={(_, newValue) => setSelectedCategory(newValue)}
            variant="scrollable"
            scrollButtons="auto"
            className="tabs-container"
          >
            <Tab 
              value="all" 
              label={
                <Box className="tab-label">
                  {categoryIcons.all}
                  <span>Todos</span>
                  <Badge 
                    badgeContent={getCategoryCount("all")} 
                    color="primary"
                    className="tab-badge"
                  />
                </Box>
              }
              className="category-tab"
            />
            {Object.entries(CATEGORY_LABELS).map(([key, label]) => (
              <Tab 
                key={key}
                value={key} 
                label={
                  <Box className="tab-label">
                    {categoryIcons[key]}
                    <span>{label}</span>
                    <Badge 
                      badgeContent={getCategoryCount(key)} 
                      color="primary"
                      className="tab-badge"
                    />
                  </Box>
                }
                className="category-tab"
              />
            ))}
          </Tabs>
        </Box>

        {filteredOptions.length > 0 ? (
          <MaintenanceGrid options={filteredOptions} />
        ) : (
          <Box className="no-results">
            <SearchIcon sx={{ fontSize: 64, color: '#ccc', mb: 2 }} />
            <Typography variant="h6" color="textSecondary">
              No se encontraron módulos
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Intenta con otros términos de búsqueda o selecciona otra categoría
            </Typography>
          </Box>
        )}
      </div>
    </PageLayout>
  );
};

export default Mantenimiento;